import { SIMPLE_DIE_ROLL } from './rules/simpleDieRoll';
import { CONSTANT } from './rules/constant';
export var CoreTokenTypes;
(function (CoreTokenTypes) {
    CoreTokenTypes["OpenParen"] = "OpenParen";
    CoreTokenTypes["CloseParen"] = "CloseParen";
    CoreTokenTypes["Operator"] = "Operator";
    CoreTokenTypes["DiceRoll"] = "DiceRoll";
})(CoreTokenTypes || (CoreTokenTypes = {}));
// Token builders used for constructing test data
export var openParenToken = function (position, content) { return ({
    type: CoreTokenTypes.OpenParen,
    position: position,
    content: content,
}); };
export var closeParenToken = function (position, content) { return ({
    type: CoreTokenTypes.CloseParen,
    position: position,
    content: content,
}); };
export var operatorToken = function (operator, position, content) { return ({
    type: CoreTokenTypes.Operator,
    position: position,
    content: content,
    operator: operator,
}); };
export var diceRollToken = function (count, numSides, position, content) { return ({
    type: CoreTokenTypes.DiceRoll,
    position: position,
    content: content,
    detailType: SIMPLE_DIE_ROLL,
    detail: { count: count, numSides: numSides },
}); };
export var constantToken = function (value, position, content) { return ({
    type: CoreTokenTypes.DiceRoll,
    position: position,
    content: content,
    detailType: CONSTANT,
    detail: value,
}); };
export var errorToken = function (position, content) { return ({
    type: 'error',
    position: position,
    content: content,
}); };
